import Vue from 'vue'
import _ from 'lodash'
import axios from 'axios'
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
import SlVueTree from '@/components/mixins/sl-vue-tree/sl-vue-tree.vue'
import {AnalysticAPI, ApprovalsAPI, DeviceAPI, DeviceGroupAPI, FavorateAPI, RemoteAPI} from '@/api'
import {history} from '@/api/analystic'
import store from '@/api/store'
import {user} from '@/api/access'
import {getExt} from '@/api/util'
import tableColumnDataReturnAPI from '@/api/table_column_data_return'
import Sidebar from '../mixins/sidebar'
import rm from './remote'
import {LiveviewDialog} from '@/components/dialogs'
import WOLDialog from '@/components/dialogs/wol.vue'
import Sortable from 'sortablejs'
import DeviceMemo from '../mixins/device-memo'
import {EventBus} from '../manage/EventBus'
import AgentInfoEditDialog from '@/components/device/components/agentInfoEditDialog.vue'

const storeKey = `devices`
let lastViewMode = 'table'

const hasAttr = (o, a) => {
  for (let i = 0; i < a.length; i++) {
    let v = a[i]
    if (typeof o[v] !== 'string') return false
  }
  return true
}

export default {
  name: 'device-component',
  components: { Sidebar, Waterfall, WaterfallSlot, LiveviewDialog, WOLDialog, SlVueTree, DeviceMemo, AgentInfoEditDialog},
  methods: {
    downloadExcel () {
      this.excelLoaded = false
      let params = {
        by: 'device_name',
        order: 'desc',
        start_date: '2022-12-20',
        end_date: '2022-12-20',
        export_id: 'deviceTable'
      }

      AnalysticAPI.excel.post('', params)
        .then((resp) => {
          const timestamp = new Date().getTime();

          this.excelLoaded = true

          if (!resp.data.objects.length) {
            const downloadUrl = resp.data.objects.download_url
            const fileName = resp.data.objects.file_name

            if (process.env.VUE_APP_SCI) {
              this.excelLink = `${this.AppState.Path.origin}:8443${downloadUrl}/${fileName}?cache=${timestamp}`
            } else {
              this.excelLink = `${this.AppState.Path.origin}${downloadUrl}/${fileName}?cache=${timestamp}`
            }

            location.href = this.excelLink

          } else {
            this.$awn.warning(this.$t('device_excel_fail'))
          }
        })
    },
    imageLoaded ({target}) {
      let {width, height} = target
      if (width > height) {
        target.className = 'w-100'
      }
      else {
        target.className = 'h-100'
      }
    },
    imageError ({target}) {
      target.src = `${this.AppState.Path.image}/live/live_no_img.jpg`
    },
    setFavorate (dev) {
      let apiCall
      
      if (dev.favorate) {
        apiCall = FavorateAPI.delete('', {params: {favnum: dev.favorate.pk}})
          .then(resp => {
            dev.favorate = null
          })
      } else {
        apiCall = FavorateAPI.post('', {servernum: dev.pk})
          .then(resp => {
            dev.favorate = resp.data.objects
          })
      }
      
      apiCall.finally(() => {
        this.getDataFromServer('devices')
      })
    },
    getAlive (id) {
      return id === 1
        ? 'toggle-on'
        : 'toggle-off'
    },
    getOS (id) {
      switch (id) {
        case 1: return 'windows'
        default: return 'windows'
      }
    },
    setFilterKey(value) {
      this.filters.value = null
      this.filterPreValue = null
      this.filters.key = _.find(this.filters.keyOptions, { value })
      this.$nextTick(() => {
        this.filterPreValue = ""
      })
    },
    setFilterValue () {
      this.filters.value = this.filterPreValue
    },
    // @@@
    setViewMode (mode) {
      if (!mode) {
        let params = {
          context: {path: 'not_save_warning'},
          withoutInput: true,
          submit: {
            size: 'sm',
            color: 'danger',
            text: 'off-editmode'
          }
        }
        this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
          if (key === 'submit') {
            this.viewMode = lastViewMode
          }
        })
        return
      }
      if (mode !== 'edit') lastViewMode = mode
      if (this.viewMode === 'edit') {
        _.each(this.devicelist, v => { v._isSelected = false })
      }
      if (mode === 'live' && !this.AppState.isCorporate) this.AppState.$emit('show-block-dialog')
      else this.viewMode = mode

      if (mode === 'card') {
        this.AppState.isIconView = this.simpleMode
        store.set('icon_view', this.simpleMode)
      } else
        this.AppState.isIconView = this.simpleMode
        store.set('icon_view', this.simpleMode)
    },
    showLiveView (device) {
      this.liveView.alive = device.alive
      this.liveView.source = `${this.AppState.Path.live}/${device.guid}.${device._ext}?cache=${this.timestamp}`
      this.liveView.show = true
    },
    liveViewChange (value) {
      this.liveView.show = value
    },
    viewDetail (item) {
      // (item, index, event)
      this.$router.push({
        name: 'device-detail',
        params: {devicePk: item.pk},
        query: this.$route.query
      })
    },
    showWOLList (dev) {
      this.wol.device = dev
      this.wol.show = true
    },
    groupDialogOpen () {
      this.groupDialog.show = true
    },
    openModal (name, device) {
      if (name === 'restart' && device === null) {
        let selects = _.filter(this.devicelist, v => v.checkbox)
        device = selects[0];
      }

      if (device.alive === 0) {
        let params = {
          title: 'LinkMeMine',
          context: {path: 'not_online_warning'}
        }
        this.AppState.$emit('show-message-dialog', params)
        return
      }

      const {isMobile, isApplication, os} = this.AppState
      if (isMobile && !isApplication && name === 'remote') {
        let params = {
          context: {
            path: 'mobile_store',
            args: { url: this.AppState.mobile[os] }
          }
        }
        return this.AppState.$emit('show-message-dialog', params)
      }

      const {ua} = this.AppState
      let descName = ua.os.name === 'Mac OS' ? 'desc_mac' : 'desc'
      let params = {
        title: this.$t(`remote.${name}.title`),
        context: (!this.AppState.isMobile && name === 'remote')
          ? this.$t(`remote.${name}.desc`) + this.$t(`remote.${name}.desc_additional`)
          : this.$t(`remote.${name}.desc`),
        sort: 'device',
        buttons: [
          {
            size: 'sm',
            color: 'primary',
            text: this.$t('execute'),
            action: (close) => {
              const resp = rm[name](device)
              if (resp === false) {
                this.$awn.alert(this.$t('not_supported_os'))
              } else if (resp === 'urlscheme') {
                void 0
              } else {
                this.$awn.success(this.$t(`remote.${name}.${resp}`))
              }
              close()
            }
          }
        ]
      }

      if (name === 'reboot' || name === 'shutdown') {
        params.buttons[0].color = 'danger';
      }

      if (!!process.env.VUE_APP_USE_ACTIVEX && ua.browser.name === 'IE') {
        params.buttons.unshift({
          size: 'sm',
          color: 'secondary',
          text: this.$t('execute') + this.$t('program') + ' ' + this.$t('download'),
          action: (close) => {
            const noActiveX = true
            const resp = rm[name](device, noActiveX)
            if (resp === false) this.$awn.alert(this.$t('not_supported_os'))
            this.$awn.success(this.$t(`remote.${name}.${resp}`))
            close()
          }
        })
      }

      if (ua.os.name === 'Mac OS' /*&& window.navigator.maxTouchPoints === 0*/) {
        params.buttons.unshift({
          size: 'sm',
          color: 'secondary',
          text: this.$t('program') + ' ' + this.$t('download'),
          action: () => {
            window.open(`${this.AppState.Path.download}/lmmviewer/LinkMeMine_Viewer_installer.zip?cache=200528_01`, '_blank')
          }
        })
      }

      //보안서약서
      if (name === 'remote' && device.security_agreement) {
        let params = {
          title: 'test'
        }
        this.AppState.$emit('show-security-dialog', params, (key, data) => {
          if (key == 'submit') {
            let params = {
              title: this.$t(`remote.${name}.title`),
              context: this.$t(`remote.${name}.desc`),
              buttons: [
                {
                  size: 'sm',
                  color: 'primary',
                  text: this.$t('execute'),
                  action: (close) => {
                    const resp = rm[name](device)
                    if (resp === false) this.$awn.alert(this.$t('not_supported_os'))
                    this.$awn.success(this.$t(`remote.${name}.${resp}`))
                    close()
                  }
                }
              ]
            }

            this.AppState.$emit('show-action-dialog', params)
          }
        })
        return
      }
      
      // 실행 버튼은 스키마, 다운로드 이벤트로 다운로드 실행을 해야하기 때문에 들어감.
      if (name === 'remote') {
        params.requestType = 'remote'
        params.device = device
      }

      this.AppState.$emit('show-action-dialog', params)
    },
    warningModal(name, device) {
      // const {isMobile, isApplication, os} = this.AppState
      const {ua} = this.AppState
      let descName = ua.os.name === 'Mac OS' ? 'desc_mac' : 'desc'
      let params = {
        title: this.$t(`remote.${name}.title`),
        context: this.$t(`remote.${name}.${descName}`),
        sort: 'device',
        buttons: [
          {
            size: 'sm',
            color: 'danger',
            text: this.$t('execute'),
            action: (close) => {
              const resp = rm[name](device)
              if (resp === false) this.$awn.alert(this.$t('not_supported_os'))
              else this.$awn.success(this.$t(`remote.${name}.${resp}`))
              close()
            }
          }
        ]
      }
      this.AppState.$emit('show-warning-dialog', params)
    },
    addGroup () {
      const companyKey = user().company_fk
      let group_fk = this.$route.params.groupPk
      let root_group_fk = null
      let group = null
      if(group_fk) {
        group_fk = parseInt(group_fk, 10)
        group = _.find(this.grouplist, { pk: group_fk })
        if (group) root_group_fk = _.find(this.grouplist, { pk: group_fk }).root_group_fk
        else group_fk = null
        if (!root_group_fk) root_group_fk = group_fk
      }
      else group_fk = null

      let params = {
        context: group_fk
          ? {title: this.$t('add-group-child'), path: 'add_child_group', args: {name: group.name}}
          : {title: this.$t('add-group'), path: 'add_root_group'},
        limit: 40,
        placeholder: 'name',
        submit: {
          size: 'sm',
          color: 'primary',
          text: 'create'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {

          let params = {
            name: data,
            flag_df_group: false,
            flag_confirm: false,
            group_fk,
            root_group_fk,
            company_fk: companyKey
          }
          DeviceGroupAPI.post('', params)
            .then(resp => {
              if (resp.data.objects.overlap) {
                this.$awn.alert(this.$t('duplication_group_name'))
              } else {
                const group = resp.data.objects
                this.grouplist.push(group)
                store.update('devices', ({groups}) => {
                  group.has_permission = true
                  groups.push(group)
                })
                this.setNodes()
                this.$awn.success(this.$t('created_group'))
              }
            })
        }
      })
    },
    removeGroup () {
      let params = {
        context: {path: 'confirm_delete_group'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'delete_group'}
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {
          let pk = this.$route.params.groupPk
          DeviceGroupAPI.delete(`${pk}`)
            .then(resp => {
              _.remove(this.grouplist, v => v.pk === pk)
              store.update('devices', ({groups}) => {
                _.remove(groups, v => v.pk === pk)
              })
              this.$awn.success(this.$t('deleted_group'))
              this.setNodes()
              this.$nextTick(() => {
                this.$router.replace({name: 'device-root'})
              })
            })
        }
      })
    },
    setCardItemSize (type) {
      if (type === 'smaller') {
        if (this.cardSize.current === 0) return
        this.cardSize.current--
      }
      else if (type === 'bigger') {
        if (this.cardSize.current === this.cardSize.sizes.length - 1) return
        this.cardSize.current++
      }
    },
    backToParent () {
      const pk = this.$route.params.groupPk
        ? parseInt(this.$route.params.groupPk, 10)
        : null
      if (pk) {
        let selected = _.find(this.grouplist, {pk})
        if (selected.root_group_fk) this.$router.push({ query: { group: selected.group_fk } })
        else this.$router.push({ query: { group: null } })
      }
    },
    getFavorate () {
      FavorateAPI.get('')
        .then(({data}) => {
          this.$log.info('[LOAD FAVORATES]')
          let devs = _.cloneDeep(this.devicelist)
          _.each(devs, v => {
            v.favorate = null
          })
          _.each(data.objects, v => {
            let dev = _.find(devs, {pk: v.dev_pk})
            if (dev) dev.favorate = v
          })
          this.devicelist = devs
          this.setNodes()
        })
    },
    groupPermFilter (groups) {
      let perm = _.filter(groups, { has_permission: true })

      const addParent = (fk) => {
        if (!fk) return
        let exist = _.find(perm, { pk: fk })
        if (exist) return
        let parent = _.find(groups, { pk: fk })
        if (!parent) {
          this.$log.error('[INVALID PARENT GROUP] ' + fk)
          return
        }
        if (parent) perm.push(parent)
        if (parent.root_group_fk) addParent(parent.group_fk)
      }
      _.each(perm, v => {
        let fk = v.group_fk
        addParent(fk)
      })
      return perm
    },
    getProcessData (item) {
      DeviceAPI.get(`${item.pk}`)
        .then(resp => {
          let {objects} = resp.data
          if (hasAttr(objects, ['prcss_name', 'prcss_cpu_usage', 'prcss_memory_usage'])) {
            this.processData = _.map(
              _.zip(
                objects.prcss_name.split(';'),
                objects.prcss_cpu_usage.split(';').map(v => parseInt(v, 10)),
                objects.prcss_memory_usage.split(';').map(v => parseInt(v, 10))
              ),
              values => _.zipObject(['name', 'cpu', 'memory'], values)
            )
          }
          objects.memory_uses = Math.round((objects.memory_usage / 100) * objects.memory_capacity)
          objects.hdd_uses = Math.round((objects.hdd_usage / 100) * objects.hdd_capacity)
          this.device = objects
        })
    },
    getSystemUsage () {
      DeviceAPI.get(`/system_usage`)
        .then(resp => {
          this.devicelist = _.map(this.devicelist, data => {
            const systemUsage = _.find(resp.data.objects, {device_fk: data.pk})
            
            if (systemUsage) {
              const updatedSystemUsage = _.omit(systemUsage, ['pk']);
              return _.assign({}, data, updatedSystemUsage);
            }
            return data
          })
        })
    },
    getDataFromServer (storeKey) {
      this.$log.info('[LOAD DATA FROM SERVER]')
      this.isBusy = true
      let params = {
        by: 'device_name',
        device_group_pk: 'all',
        order: 'desc',
        search_mode: 'normal'
      }
      axios.all([
        DeviceGroupAPI.get(''),
        DeviceAPI.get('', {params}),
        FavorateAPI.get('')
      ]).then(
        axios.spread((group, devices, favs) => {
          this.page.total = devices.data.meta.total_count
          this.devicelist = _.map(devices.data.objects, v => {
            v.aliasNew = v.alias
            v.memoNew = v.memo
            v.favorate = null
            return v
          })

          _.each(favs.data.objects, v => {
            let dev = _.find(this.devicelist, {pk: v.dev_pk})
            if (dev) dev.favorate = v
          })
          let groupTmp = this.groupPermFilter(group.data.objects)
          groupTmp = _.sortBy(
            groupTmp,
            [
              o => {
                if (o.name === 'ROOT') {
                  return '0'
                }
                return o.name
              }
            ]
          )
          this.grouplist = groupTmp
          store.set(storeKey, {
            devices: this.devicelist,
            groups: this.grouplist,
            updatedAt: new Date().getTime()
          })
          this.setNodes()
          this.calcLicense()
          this.isBusy = false
        })
      )
      this.isCheckAll = false
      this.isIndeterminate = false
    },
    editDeviceName(device){
      let agent_info = null
      let isMultipleSelection = false
      
      if (device == null && this.selectedDevices.length > 1) {
        isMultipleSelection = true
      }
      
      this.dialogData = {
        context: {
          title: this.$t(`device_setting_edit`),
          namePath: isMultipleSelection ? 'device_config_desc' : 'device_name_desc',
          nameInputPath: 'name_input_path',
          settingPath: 'device_setting_desc',
          isMultipleSelection: isMultipleSelection,
          args: {}
        },
        placeholder:'columns.alias',
        limit: 64,
        submit: {
          size: 'sm',
          color: 'primary',
          text: 'submit'
        }
      }
      
      // 다중 선택한 경우에 대한 분기
      if (isMultipleSelection) {
        this.dialogData.userList = this.selectedDevices.map(i => ({
          devicePk: i.pk,
          uid: i.guid,
          appConfigName: i.app_config_name,
          appConfigFk: i.app_config_fk,
        }))
      } else {
        // 테이블 기능 단일 상태일 경우
        if (device) {
          agent_info = device
        } else {
          // 테이블 헤더 기능 단일 상태일 경우
          let selects = _.filter(this.devicelist, v => v.checkbox)
          agent_info = selects[0]
        }
        
        this.dialogData.value = agent_info.alias
        this.dialogData.devicePk = agent_info.pk
        this.dialogData.appConfigPk = agent_info.app_config_fk
        this.dialogData.appConfigName = agent_info.app_config_name
        this.dialogData.guid = agent_info.guid
        this.dialogData.devOsId = agent_info.dev_os_id
        this.dialogData.context.args.alias = agent_info.alias;
      }
    },
    handleDialogSubmit(value) {
      if (!value) return this.getDataFromServer('devices')
      
      const {oldValue, newValue, devicePk, appConfigPk, oldConfigName, newConfigName} = value
      // 구성만 변경할 가능성이 있기 때문에 해당 부분 주석.
      // if (oldValue === newValue) {
      //   return this.AppState.$emit('show-message-dialog', { context: { path: 'device_name_identical' } })
      // }
      let path = ''
      if (oldValue !== newValue && oldConfigName !== newConfigName) {
        path = 'all_different';
      } else if (oldValue !== newValue) {
        path = 'device_name_confirm';
      } else if (oldConfigName !== newConfigName) {
        path = 'device_config_confirm';
      }
      
      DeviceAPI.put(devicePk.toString(), { alias: newValue, app_config_fk: appConfigPk})
          .then(resp => {
            this.AppState.$emit('show-message-dialog',
                { context:
                  {
                    title: this.$t('notify'),
                    path: path,
                    args: { alias: oldValue, value: newValue, oldConfigName: oldConfigName, newConfigName: newConfigName }
                  }
                }
            )
            store.set(storeKey, {
              devices: this.devicelist,
              groups: this.grouplist,
              updatedAt: new Date().getTime()
            })
            this.getDataFromServer('devices')
          })
    },
    applyAgentConfig (device) {
      let data = null
      let isMultipleSelection = false
      
      if (device == null && this.selectedDevices.length > 1) {
        isMultipleSelection = true
      }
      
      if (isMultipleSelection) {
        let array = this.selectedDevices.filter(i => i.alive === 1)
        data = array.map(i => i.guid)
      } else {
        // 테이블 기능 단일 상태일 경우
        if (device) {
          data = device.guid
        } else {
          // 테이블 헤더 기능 단일 상태일 경우
          let selects = _.filter(this.devicelist, v => v.checkbox)
          data = selects[0].guid
        }
      }
      
      rm['information'](data)
      this.$awn.success(this.$t("updated_config_applied"))
    },
    updateRow (dev) {
      if (dev.aliasNew) {
        DeviceAPI.put(dev.pk.toString(), { alias: dev.aliasNew })
          .then(resp => {
            dev.alias = dev.aliasNew
            store.set(storeKey, {
              devices: this.devicelist,
              groups: this.grouplist,
              updatedAt: new Date().getTime()
            })
          })
      }
      if (dev.memoNew) {
        DeviceAPI.put(dev.pk.toString(), { memo: dev.memoNew })
          .then(resp => {
            dev.memo = dev.memoNew
            store.set(storeKey, {
              devices: this.devicelist,
              groups: this.grouplist,
              updatedAt: new Date().getTime()
            })
          })
      }
    },
    removeDevice (dev) {
      let params = {
        context: {
          title: this.$t('delete_device'),
          path: 'confirm_delete_device',
          args: {name: dev.alias}
        },
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'primary',
          text: {path: 'delete'}
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return

        history.post('audit', {
          act_name_id: 13,
          act_type_id: 5,
          device_pk: dev.pk,
          member_pk: user().pk,
          new_value: dev.alias,
          old_value: dev.dev_os_id
        })

        rm.remove(dev)
        DeviceAPI.delete(`${dev.pk}`)
          .then(resp => {
            this.AppState.$emit('show-message-dialog', { context: {path: 'deleted_device'} })
            this.goback()
            this.AppState.$emit('device-state-change')
          })
      })
    },
    showAgentLocationDialog(dev) {
      let params = {
        context: {
          title: this.$t('device_location'),
          latitude: dev.latitude,
          longitude: dev.longitude,
          agentName: dev.alias,
        }
      }
      this.AppState.$emit('show-agent-map-dialog', params)
    },
    removeSelectedDevice () {
      let selects = _.filter(this.devicelist, v => v.checkbox)
      if (!selects.length) {
        this.$awn.warning(this.$t('no-selects'))
        return undefined
      }

      const total = selects.length
      let count = 0

      let params = {
        context: {
          title: this.$t('delete_device'),
          path: 'confirm_delete_device',
          args: {name: selects.map(v => v.alias).join(', ')}
        },
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'delete'}
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        _.each(selects, dev => {
          rm.remove(dev)
          DeviceAPI.delete(`${dev.pk}`)
            .then(resp => {
              this.$awn.success(this.$t('deleted_device_count', {count: ++count, total}))
              if (count === total) {
                this.AppState.$emit('device-state-change')
              }
            })
        })
      })
    },
    // 다수의 에이전트를 체크한 기능 관련 내용(restart, update)
    functionSelectedDevice (type) {
      if (!this.selectedDevices.length) {
        this.$awn.warning(this.$t('no-selects'))
        return undefined
      }
      
      let isOffline  = this.selectedDevices.some(device => device.alive === 0)
      let aliveDevices = this.selectedDevices.filter(device => device.alive === 1)
      
      const {ua} = this.AppState
      let descName = ua.os.name === 'Mac OS' ? 'desc_mac' : 'descs'
      
      let title, context, action
      
      if (type === 'update') {
        title = this.$t('permissions.CSUpdate')
        context = this.$t('update_agent_descs')
        action = async  (close) => {
          for (const device of this.selectedDevices) {
            await RemoteAPI.put(`${device.guid}`, {type: 'update'})
          }
          this.$awn.success(this.$t('update_agent_requested'))
          close()
        }
      } else if (type === 'restart') {
        title = this.$t(`remote.${type}.title`)
        context = this.$t(`remote.${type}.${descName}`)
        action = async (close) => {
          for (const device of aliveDevices) {
            await rm[type](device)
          }
          if (isOffline) {
            this.$awn.success(this.$t('online_agents_restart'))
          }
          else {
            this.$awn.success(this.$t('all_agents_restart'))
          }
          close()
        }
      }
      
      let params = {
        title: title,
        context: context,
        sort: 'device',
        buttons: [
          {
            size: 'sm',
            color: 'primary',
            text: this.$t('execute'),
            action: action,
          }
        ]
      }
      this.AppState.$emit('show-action-dialog', params)
    },
    setDevGroup () {
      const treeApi = this.$refs.treeView
      let selectNode = treeApi.getSelected()
      if (!selectNode.length) {
        this.$awn.warning(this.$t('please_select_group'))
        return undefined
      }
      let group = selectNode[0].data
      let selects = _.filter(this.devicelist, v => v.checkbox)
      if (!selects.length) {
        this.$awn.warning(this.$t('no-selects'))
        return undefined
      }
      let count = selects.length

      _.each(selects, v => {
        if (group.pk == v.device_group_fk) {
          this.AppState.$emit('show-message-dialog', { context: {path: 'identical_group'} })
          return undefined
        }
        let params = {
          device_pk: v.pk,
          new_device_group_fk: group.pk,
          old_device_group_fk: v.device_group_fk
        }

        DeviceAPI.post('', params)
          .then(resp => {
            v.device_group_fk = group.pk
            v.checkbox = false
            this.$awn.success(this.$t('moved_device', {device: v.alias, group: group.name}))
            count--
            if(count === 0) {
              this.setNodes()
              store.set(storeKey, {
                devices: this.devicelist,
                groups: this.grouplist,
                updatedAt: new Date().getTime()
              })
              this.groupDialog.show = false
            }
            this.setNodes();
          })
      })
    },
    valueChange (key, value, data) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}, DATA: ${data}]`)

      DeviceAPI.put(`${data.pk}`, { memo: value })
        .then(resp => {
          this.AppState.$emit('show-message-dialog', { context: {path: 'updated_memo'} })
          data.memo = value
          const devpk = data.pk
          let pdev = _.find(this.devicelist, v => v.pk === devpk)
          pdev.memo = value
          pdev.memoNew = value
          store.update('devices', ({devices}) => {
            let devn = _.find(devices, v => v.pk === devpk)
            devn.memo = value
            devn.memoNew = value
          })
        })

    },
    updateMemo (dev) {

      if (!this.AppState.perm.modifyInformation) return
      let params = {
        context: {path: 'please_input_memo'},
        value: dev.memo,
        limit: 140,
        placeholder: this.$t('columns.memo'),
        textarea: true,
        nullable: true,
        submit: {
          size: 'sm',
          color: 'primary',
          text: 'submit'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, value) => {
        if (key !== 'submit') return
        DeviceAPI.put(`${dev.pk}`, { memo: value })
          .then(resp => {
            this.AppState.$emit('show-message-dialog', { context: {path: 'updated_memo'} })
            dev.memo = value
            const devpk = dev.pk
            let pdev = _.find(this.devicelist, v => v.pk === devpk)
            pdev.memo = value
            pdev.memoNew = value
            store.update('devices', ({devices}) => {
              let devn = _.find(devices, v => v.pk === devpk)
              devn.memo = value
              devn.memoNew = value
            })
          })
      })
    },
    selectNode (node, ev) {
      if (!ev) return
      if (ev.target.tagName.toLowerCase() !== 'div') return
      let {data} = node[0]
      // if (node[0].isLeaf) {
      //   if (this.$route.name === 'device-detail' && this.$route.params.devicePk === data.pk) return;
      //   this.$router.push({name: 'device-detail', params: {devicePk: `${data.pk}`}})
      // }
      // else {
      if(node[0].isLeaf) return;
      
      // 다른 그룹으로 이동할때 테이블 전체선택 및 선택된 항목 uncheck
      this.selectedCount = 0
      this.isCheckAll = false
      this.isIndeterminate = false
      _.each(this.devicelist, v => {
        v.checkbox = false;
      })

      if (data.pk) {
        if (this.$route.name === 'deviceAll' && this.$route.params.groupPk === data.pk) return;
        this.$router.push({name: 'deviceAll', params: { groupPk: data.pk }})
        this.groupCount.usage = data.device_count
        this.groupCount.limit = data.dev_limit
      }
      else {
        if (this.$route.name === 'deviceAll' && !this.$route.params.groupPk) return;
        this.$router.push({name: 'deviceAll'})
        this.filters.value = null
        this.filterPreValue = null
      }
      // }
    },
    onNodeDoubleClick(node, ev) {
      if (!ev) return
      if (ev.target.tagName.toLowerCase() !== 'div' && ev.target.tagName.toLowerCase() !== 'span') return
      if (!node.isLeaf) return
      let {data} = node
      if (this.$route.name === 'device-detail' && this.$route.params.devicePk === data.pk) return;
      this.$router.push({name: 'device-detail', params: {devicePk: `${data.pk}`}})
    },
    dropNode (nodes, position, event) {
      // const treeApi = this.$refs.treeView
      let target = nodes[0]
      let dest = position.node
      let {placement} = position

      // @@@ 이것 때문에 사이드바 드래그앤드롭이 안되었음.
      // if (!target.data.has_permission) {
      //   this.$awn.warning(this.$t('no_perm_group'))
      //   return
      // }
      if (!target.data.pk) {
        this.$awn.warning(this.$t('moved_device_fail', {name: this.$t('all_device')}))
        return
      }
      if (target.data.flag_df_group) {
        this.$awn.warning(this.$t('moved_device_fail', {name: this.$t('reserved.ROOT')}))
        return
      }
      if (dest.isLeaf) {
        let params = {
          device_pk: target.data.pk,
          new_device_group_fk: dest.data.device_group_fk,
          old_device_group_fk: target.data.device_group_fk
        }

        if (params.new_device_group_fk === params.old_device_group_fk)
          return this.AppState.$emit('show-message-dialog', { context: {path: 'identical_group'} })

        DeviceAPI.post('', params)
          .then(resp => {
            let index = _.findIndex(this.devicelist, {pk: target.data.pk})
            this.devicelist[index].device_group_fk = dest.data.device_group_fk
            this.$awn.success(this.$t('moved_device', {device: target.data.alias, group: dest.data.device_group_name}))
            store.set(storeKey, {
              devices: this.devicelist,
              groups: this.grouplist,
              updatedAt: new Date().getTime()
            })
            if (!this.expandedList.includes(dest.data.device_group_fk)) {
              this.expandedList.push(dest.data.device_group_fk)
            }
            this.setNodes()
          })
        return
      }

      if (placement === 'inside') {
        if (!dest.data.pk) {
          this.$awn.warning(this.$t('all_device_has_no_child'))
          return
        }
        if (target.isLeaf) {
          let params = {
            device_pk: target.data.pk,
            new_device_group_fk: dest.data.pk,
            old_device_group_fk: target.data.device_group_fk
          }

          if (params.new_device_group_fk === params.old_device_group_fk) {
            return this.AppState.$emit('show-message-dialog', { context: {path: 'identical_group'} })
          }
          DeviceAPI.post('', params)
            .then(resp => {
              let index = _.findIndex(this.devicelist, {pk: target.data.pk})
              this.devicelist[index].device_group_fk = dest.data.pk
              this.$awn.success(this.$t('moved_device', {device: target.data.alias, group: dest.data.name}))
              store.set(storeKey, {
                devices: this.devicelist,
                groups: this.grouplist,
                updatedAt: new Date().getTime()
              })
              if (!this.expandedList.includes(dest.data.pk)) {
                this.expandedList.push(dest.data.pk)
              }
              this.setNodes()
            })
        }
        else {
          let index = _.findIndex(this.grouplist, {pk: target.data.pk})
          let params = {}

          if(this.grouplist[index].group_fk === dest.data.pk) {
            return this.AppState.$emit('show-message-dialog', { context: {path: 'identical_group'} })
          }
          
          this.grouplist[index].group_fk = dest.data.pk
          params.group_fk = dest.data.pk

          if (dest.data.root_group_fk === null) params.root_group_fk = dest.data.pk
          else params.root_group_fk = dest.data.root_group_fk

          DeviceGroupAPI.put(`${target.data.pk}`, params)
            .then(resp => {
              this.grouplist[index].group_fk = params.group_fk
              this.grouplist[index].root_group_fk = params.root_group_fk
              this.$awn.success(this.$t('moved_device', {device: target.data.name, group: dest.data.name}))
              store.set(storeKey, {
                devices: this.devicelist,
                groups: this.grouplist,
                updatedAt: new Date().getTime()
              })
              if (!this.expandedList.includes(dest.data.pk)) {
                this.expandedList.push(dest.data.pk)
              }
              this.setNodes()
            })
        }
      }
      else {
        if (target.isLeaf && placement === 'after') {
          let params = {
            device_pk: target.data.pk,
            new_device_group_fk: dest.data.pk,
            old_device_group_fk: target.data.device_group_fk
          }
          DeviceAPI.post('', params)
            .then(resp => {
              let index = _.findIndex(this.devicelist, {pk: target.data.pk})
              this.devicelist[index].device_group_fk = dest.data.pk
              this.$awn.success(this.$t('moved_device', {device: target.data.alias, group: dest.data.name}))
              store.set(storeKey, {
                devices: this.devicelist,
                groups: this.grouplist,
                updatedAt: new Date().getTime()
              })
              if (!this.expandedList.includes(dest.data.pk)) {
                this.expandedList.push(dest.data.pk)
              }
              this.setNodes()
            })
        }
        else if (target.isLeaf && placement === 'before') {
          event.preventDefault()
        }
        else {
          if (target.data.group_fk === dest.data.group_fk) {
            this.$awn.warning(this.$t('no_order_warning'))
            return
          }
          let params = {
            group_fk: dest.data.group_fk || -1,
            root_group_fk: dest.data.root_group_fk || -1
          }
          DeviceGroupAPI.put(`${target.data.pk}`, params)
            .then(resp => {
              let index = _.findIndex(this.grouplist, {pk: target.data.pk})
              this.grouplist[index].group_fk = dest.data.group_fk
              this.grouplist[index].root_group_fk = dest.data.root_group_fk
              this.$awn.success(this.$t('moved_device_by', {device: target.data.name, group: dest.data.name}))
              store.set(storeKey, {
                devices: this.devicelist,
                groups: this.grouplist,
                updatedAt: new Date().getTime()
              })
              this.setNodes()
            })
        }
      }
    },
    calcLicense () {

      if(process.env.VUE_APP_STANDALONE) {
        // 
        return;
      }

      const license = user().license
      if (license.total.vol < this.devicelist.length) {
        this.licenseDialog.summary = {
          fields: [
            { key: 'expDate', label: this.$t('end_time'), thClass: 'text-center', tdClass: 'text-center' },
            { key: 'expVol', label: this.$t('device_vol'), thClass: 'text-center', tdClass: 'text-center' },
            { key: 'vol', label: this.$t('available_count'), thClass: 'text-center', tdClass: 'text-center' }
          ],
          items: [
            {
              vol: license.total.vol,
              expVol: this.devicelist.length - license.total.vol,
              expDate: license.total.lastestExpireDateString
            }
          ]
        }
        this.licenseDialog.devices = {
          fields: [
            { key: 'alias', label: this.$t('device_name') },
            { key: 'device_group_name', label: this.$t('group') },
            // { key: 'dev_os_id', label: 'O/S', thClass: 'text-center', tdClass: 'text-center' },
            // { key: 'status', label: this.$t('status'), thClass: 'text-center', tdClass: 'text-center' },
            { key: 'last_connected_time', label: this.$t('columns.last_connected_time'), thClass: 'text-center', tdClass: 'text-center' },
            { key: 'remove', label: this.$t('delete'), thClass: 'text-center', tdClass: 'text-center' }
          ]
        }
        this.licenseDialog.show = true
      }
    },
    setNodes () {
      let result = []
      let resultGroups = []
      let dpk = this.$route.params.devicePk
        ? parseInt(this.$route.params.devicePk, 10)
        : null
      let gpk = /\d+/.test(this.$route.params.groupPk)
        ? parseInt(this.$route.params.groupPk, 10)
        : this.$route.params.groupPk
      let selectedGroup = null
      let favoritesCount = 0;

      let groups = _.map(this.grouplist, v => {
        if (gpk && gpk === v.pk) selectedGroup = v
        v.deviceCount = 0
        const isDefaultGroup = v.name === "ROOT"
        return {
          isLeaf: false,
          isExpanded: false,
          isDraggable: isDefaultGroup ? false : this.AppState.perm.isAdmin,
          isSelected: (!dpk && gpk === v.pk),
          title: v.name,
          pk: v.pk,
          root_group_fk: v.root_group_fk,
          group_fk: v.group_fk,
          data: v
        }
      })
      let onlyGroups = _.cloneDeep(groups)

      let devs = _.map(this.devicelist, v => {
        if (dpk === v.pk) {
          selectedGroup = _.find(this.grouplist, { pk: v.device_group_fk })
        }
        
        // 즐겨찾기된 갯수를 카운팅
        if (v.favorate) {
          favoritesCount++
        }
        
        return {
          title: v.alias,
          isLeaf: true,
          isSelected: dpk === v.pk,
          isDraggable: this.AppState.perm.isAdmin,
          pk: v.pk,
          device_group_fk: v.device_group_fk,
          data: v
        }
      })

      const setParent = (ppk) => {
        let g = _.find(groups, v => v.data.pk === ppk)
        if (!g) return
        let currentPk = Number(this.$route.params.groupPk)
        if (!this.expandedList.includes(currentPk) && !g.isSelected) {
          this.expandedList.push(currentPk)
        }
        if (!this.expandedList.includes(ppk) && !g.isSelected) {
          this.expandedList.push(ppk)
        }
        if (g.group_fk) setParent(g.data.group_fk)
      }

      if (selectedGroup) setParent(selectedGroup.group_fk || selectedGroup.pk)

      groups.forEach(v => {
        if (this.expandedList.includes(v.pk)) {
          v.isExpanded = true
        }
      })

      result = _.concat(
        _.filter(groups, {root_group_fk: null}),
        _.filter(devs, { device_group_fk: null })
      )
      resultGroups = _.filter(onlyGroups, {root_group_fk: null})

      let treePath = []
      const search = (g, counter) => {
        _.each(g, v => {
          if (v.isLeaf) return

          let scopedDev = _.filter(devs, { device_group_fk: v.pk })
          if (counter !== undefined) {
            if (v.data.root_group_fk === null) {
              treePath = [v]
              counter = 0
            }
            else {
              if (!treePath[counter]) treePath.push(v)
              else treePath[counter] = v
            }
            _.each(treePath, (v, i) => {
              if (i <= counter) {
                v.data.deviceCount += scopedDev.length
              }
            } )
          }
          v.children = _.concat(_.filter(groups, {group_fk: v.pk}), scopedDev)
          search(v.children, counter + 1)
        })
      }
      search(result, 0)

      const searchOnlyGroup = (g) => {
        _.each(g, v => {
          v.children = _.filter(onlyGroups, {group_fk: v.pk})
          search(v.children)
        })
      }
      searchOnlyGroup(resultGroups)

      result.unshift({
        isLeaf: false,
        isExpanded: false,
        isSelected: gpk === 'favorate',
        isDraggable: false,
        deviceCount: favoritesCount,
        title: 'favorate',
        pk: 'favorate',
        data: { pk: 'favorate', favorate: true, dummy: true }
      })

      result.unshift({
        isLeaf: false,
        isExpanded: false,
        isSelected: gpk === 'all',
        isDraggable: false,
        title: 'all_device',
        pk: 'all',
        data: { pk: 'all', all: true, dummy: true }
      })

      this.nodes = result
      this.groupNodes = resultGroups
    },
    approvalStatus (ctx) {
      let params = {
        context: {path: 'reset_n', args: {v: 'OTP'}},
        submit: {
          size: 'md',
          color: 'primary',
          text: 'registration',
          sort: 'new'
        },
        alias: ctx.alias,
        device_pk: ctx.pk,
      }
      this.AppState.$emit('show-approval-request-dialog', params, (key, data) => {
        if (key === 'submit') {
          let submitParams = {
            device_pk: ctx.pk,
            approver_pk: data.approver_pk,
            approver_name: data.approver_name,
            start_time: data.start_time,
            end_time: data.end_time,
            approval_reason: data.approval_reason
          }
          ApprovalsAPI.post('', submitParams)
            .then(resp => {
              this.$awn.success(this.$t('approval-success'))
            })
        }
      })
    },
    updateAgent (device) {
      if(device === null) {
        let selects = _.filter(this.devicelist, v => v.checkbox)
        device = selects[0];
      }
      let params = {
        context: {
          title: this.$t('permissions.CSUpdate'),
          path: 'update_agent_desc',
          args: { current_ver: device.dev_ver, latest_ver: device.latest_ver }
        },
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'primary',
          text: 'submit'
        }
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') return
        RemoteAPI.put(`${device.guid}`, {type: 'update'})
          .then(resp => {
            this.$awn.success(this.$t('update_agent_requested'))
          })
      })
    },
    draggableTable(item, index, event) {
      if (this.sorTableDrag) {
        this.sorTableDrag.destroy()
      }
      const el = this.$refs.deviceTableBody
      this.sorTableDrag = this.createSortable(el, item, index)
    },
    thumbnailViewDrag($event, dev) {
      if (this.sorTableDrag) {
        this.sorTableDrag.destroy()
      }
      const thumbEl = $event.currentTarget
      this.sorTableDrag = this.createSortable(thumbEl.parentNode, dev)
    },
    createSortable(el, item) {
      let sortableEl = null

      // 리스트뷰와 썸네일뷰 관련 구분자
      if (el.$el !== undefined) {
        sortableEl = el.$el.querySelector('.lmm-table-body')
      } else {
        sortableEl = el
      }

      let childElement = null
      
      const clickHandler = (item) => {
        let target = this.selectedDevices
        if (target.length === 0) {
          target = item
        }
        return target
      };

      const dragenterHandler = (e) => {
        if (e.target !== this.sidebarDragTarget.$el) {
          childElement = e.target
          this.isTargetInside = true
        }
      }

      const dragleaveHandler = (e) => {
        // 드래그 중인 아이템이 해당 요소 밖으로 나갈 때
        if (!this.sidebarDragTarget.$el.contains(e.relatedTarget)) {
          this.isTargetInside = false
        }

        if (e.target.nodeName === "path" || e.target.nodeName === "svg") return

        // 마우스가 sl-vue-tree-nodes-list 밖으로 나갈 때
        if (e.relatedTarget && e.relatedTarget.classList.contains("sl-vue-tree-root")) {
          this.isTargetInside = false
        }
      }

      const dragoverHandler = (e) => {
        e.preventDefault()
      }

      const dropHandler = (e) => {
        if (this.isTargetInside) {
          if (e.target.className.includes("root")) return

          e.preventDefault()
          this.nodeTitle = e.target.textContent.replace(/\s*\([^)]*\)\s*/g, '')

          // 드래그해서 마우스 버튼을 뗄 때 해당 node 정보를 얻음
          // 모든장치, 즐겨찾기 관련 정보는 grouplist 배열에 없어서 nodeTitle 배열을 사용.
          if (this.nodeTitle === '모든장치' || this.nodeTitle === '즐겨찾기') {
            if (this.nodeTitle === '모든장치') this.nodeTitle = "all_device"
            if (this.nodeTitle === '즐겨찾기') this.nodeTitle = "favorate"
            let index = this.nodes.findIndex((e) => e.title === this.nodeTitle)
            this.sidebarTargetNode = this.nodes[index]
          }
          else {
            let index = this.grouplist.findIndex((e) => e.name === this.nodeTitle)
            this.sidebarTargetNode = this.grouplist[index]
          }
        }
      }

      return Sortable.create(sortableEl, {
        animation: 200,
        sort: false,
        onChoose: evt => {
          this.sidebarDragTarget = this.$refs.sideTree

          this.sidebarDragTarget.$el.addEventListener('dragenter', dragenterHandler)
          this.sidebarDragTarget.$el.addEventListener('dragleave', dragleaveHandler)
          this.sidebarDragTarget.$el.addEventListener('dragover', dragoverHandler)
          this.sidebarDragTarget.$el.addEventListener('drop', dropHandler, true)
        },
        // @row-hovered 이벤트로는 최신 체크 항목이 올바르게 적용 안되는 가능성이 있기 때문에, 드래그할 때 새로 target 을 설정
        onStart: evt => {
          this.draggedTarget = clickHandler(item)
        },
        onEnd: evt => {
          this.sidebarDragTarget.$el.removeEventListener('dragenter', dragenterHandler)
          this.sidebarDragTarget.$el.removeEventListener('dragleave', dragleaveHandler)
          this.sidebarDragTarget.$el.removeEventListener('dragover', dragoverHandler)
          this.sidebarDragTarget.$el.removeEventListener('drop', dropHandler, true)
          if (this.isTargetInside && this.sidebarTargetNode) {
            this.addDevToGroup(this.draggedTarget, this.sidebarTargetNode)
            this.isTargetInside = false
          }
        }
      })
    },
    addDevToGroup (devices, node) {
      if (!Array.isArray(devices)) {
        devices = [devices];
      }
      
      let promises = devices.map(item => {
        let params = {
          device_pk: item.pk,
          new_device_group_fk: node.pk,
          old_device_group_fk: item.device_group_fk
        }

        if (params.new_device_group_fk === params.old_device_group_fk) {
          this.AppState.$emit('show-message-dialog', { context: {path: 'identical_group'} })
          return Promise.resolve()
        }


        if (this.nodeTitle === 'all_device' || this.nodeTitle === 'favorate') {
          if (this.nodeTitle === 'all_device') {
            this.$awn.alert(`해당 그룹은 '모든장치' 그룹입니다. 그룹 이동이 불가능합니다.`)
            return Promise.resolve()
          }

          if (this.nodeTitle === 'favorate') {
            this.setFavorate(item)
            item.favorate !== null ?
                this.$awn.success(`${item.alias}장치의 즐겨찾기가 해제되었습니다.`) :
                this.$awn.success(`${item.alias}장치가 즐겨찾기로 등록되었습니다.`)
            return Promise.resolve()
          }
        }
        return DeviceAPI.post('', params)
          .then(resp => {
            let index = _.findIndex(this.devicelist, { pk: item.pk })
            this.devicelist[index].device_group_fk = node.pk
            this.devicelist[index].device_group_name = node.name
            store.update('devices', ({devices}) => {
              devices[index].device_group_fk = node.pk
              devices[index].device_group_name = node.name
              this.$awn.success(`${item.alias}장치가 ${node.name}(님)의 그룹으로 이동되었습니다.`)
              if (!this.expandedList.includes(node.pk)) {
                this.expandedList.push(node.pk)
              }
              this.setNodes()
            })
          })
      })
      
      Promise.all(promises).then(() => {
        this.getDataFromServer('devices');
        this.selectedDevices = [];
        this.isIndeterminate = false
        this.isCheckAll = false
      });
    },
    getGroupName() {
      let index = _.findIndex(this.grouplist, { pk: this.$route.params.groupPk })
      return this.grouplist[index].name
    },

    // 테이블 전체선택 > uncheck / check > 선택항목 리스트 변경
    updateSelectedCount() {
      let selects = _.filter(this.devicesOnPage, v => v.checkbox)
      this.selectedCount = selects.length
      
      this.selectedDevices = selects
      // 경우 1: 전체체크 (헤더 체크박스에 체크, 모든 에이전트 항목에 체크)
      if(this.selectedCount == this.devicesOnPage.length){
        this.isIndeterminate = false
        this.isCheckAll = true
      // 경우 2: 체크없음 (헤더 체크박스 언체크, 모든 에이전트 항목에 언체크)
      } else if(this.selectedCount === 0){
        this.isIndeterminate = false
        this.isCheckAll = false
      // 경우 3: 부분체크 (헤더 체크박스 '-'값, 선택된 에이전트 항목에 체크)
      } else{
        this.isIndeterminate = true
        this.isCheckAll = false
      }
    },
    // 테이블 전체선택 
    selectAllRows() {
      // 모든 에이전트 항목에 체크
      _.each(this.devicesOnPage, v => {
        v.checkbox = this.isCheckAll;
      })
      let selects = _.filter(this.devicesOnPage, v => v.checkbox)
      this.selectedCount = selects.length
      
      /*
      위에 있는 selects 변수를 이용하면, 다른 그룹에 있더라도 all 의 그룹에 대한 전체 선택을 함.
      왜 저렇게 했는지는 의도를 모르기도 하고, 사이드 이펙트 있을 확률이 있기에
      드래그엔드롭은 기존 변수 말고, this.devices 를 이용하여 따로 사용함.
      */
      this.selectedDevices = this.devices
      // 경우 1: 전체체크 (헤더 체크박스에 체크, 모든 에이전트 항목에 체크)
      if(this.selectedCount == this.devicesOnPage.length){
        this.isIndeterminate = false
        this.isCheckAll = true
      // 경우 2: 체크없음 (헤더 체크박스 언체크, 모든 에이전트 항목에 언체크)
      } else if(this.selectedCount === 0){
        this.isIndeterminate = false
        this.isCheckAll = false
      // 경우 3: 부분체크 (헤더 체크박스 '-'값, 선택된 에이전트 항목에 체크)
      } else{
        this.isIndeterminate = true
        this.isCheckAll = false
      }
    },
    // 테이블 sort방식이 변경되었을 경우 초기화
    sortChange() {
      this.isCheckAll = false;
      this.isIndeterminate = false
      
      _.each(this.devicesOnPage, v => {
        v.checkbox = this.isCheckAll;
      })
      this.selectedCount = 0;
      this.devicesOnPage.length = 0;
    },
    // 아이콘뷰 우클릭 메뉴 옵션 구현
    showIconContextMenu(item){
      this.selectedItem = item
      this.showIconMenu = true
      // 클릭 후 메뉴 x, y 좌표
      this.$nextTick(() => {
        const menu = document.querySelector('.rightClickMenuIcon')
        menu.style.top = `${event.pageY}px`
        menu.style.left = `${event.pageX}px`
      })

      // 온라인 & 제어권있음 
      if (item.alive === 1 && item.approval === 1){
        this.contextMenuItems[this.menuIndex.remote].status = 1;
        this.contextMenuItems[this.menuIndex.wol].status = 0;
        this.contextMenuItems[this.menuIndex.approve].status = 0;
        this.contextMenuItems[this.menuIndex.live].status = 1;
        this.contextMenuItems[this.menuIndex.update].status = 1;
        this.contextMenuItems[this.menuIndex.restart].status = 1;
        if(this.AppState.perm.CSFileManager && !item.disable_filetransfer){
          this.contextMenuItems[this.menuIndex.transfer].status = 1;
        }
        if(this.AppState.perm.useFunction){
          this.contextMenuItems[this.menuIndex.delete].status = 1;
          this.contextMenuItems[this.menuIndex.reboot].status = 1;
          this.contextMenuItems[this.menuIndex.shutdown].status = 1;
        }
      }

      // 온라인 & 제어권없음
      else if (item.alive === 1 && item.approval === 0){
        this.contextMenuItems[this.menuIndex.remote].status = 0;
        this.contextMenuItems[this.menuIndex.transfer].status = 0;
        this.contextMenuItems[this.menuIndex.wol].status = 0;
        this.contextMenuItems[this.menuIndex.approve].status = 1;
        this.contextMenuItems[this.menuIndex.live].status = 0;
        this.contextMenuItems[this.menuIndex.update].status = 0;
        this.contextMenuItems[this.menuIndex.restart].status = 0;
        this.contextMenuItems[this.menuIndex.delete].status = 0;
        this.contextMenuItems[this.menuIndex.reboot].status = 0;
        this.contextMenuItems[this.menuIndex.shutdown].status = 0;
      }

      // 오프라인
      else if (item.alive === 0){
        this.contextMenuItems[this.menuIndex.remote].status = 0;
        this.contextMenuItems[this.menuIndex.transfer].status = 0;
        this.contextMenuItems[this.menuIndex.approve].status = 0;
        this.contextMenuItems[this.menuIndex.live].status = 0;
        this.contextMenuItems[this.menuIndex.update].status = 0;
        this.contextMenuItems[this.menuIndex.restart].status = 0;
        this.contextMenuItems[this.menuIndex.reboot].status = 0;
        this.contextMenuItems[this.menuIndex.shutdown].status = 0;
        if(this.AppState.perm.useFunction){
          this.contextMenuItems[this.menuIndex.delete].status = 1;
        }
        if(this.AppState.isCorporate && this.AppState.perm.useFunction){
          this.contextMenuItems[this.menuIndex.wol].status = 1;
        }
      }
    },
    // 리스트뷰 우클릭 메뉴 옵션 구현
    showContextMenu(item, index, evt) {
      evt.preventDefault()
      this.selectedItem = item
      this.showMenu = true

      this.$nextTick(() => {
        const menu = document.querySelector('.rightClickMenu')
        menu.style.top = `${evt.pageY}px`
        menu.style.left = `${evt.pageX}px`
      })

      // 온라인 & 제어권있음
      if (item.alive === 1 && item.approval === 1){
        this.contextMenuItems[this.menuIndex.remote].status = 1;
        this.contextMenuItems[this.menuIndex.wol].status = 0;
        this.contextMenuItems[this.menuIndex.approve].status = 0;
        this.contextMenuItems[this.menuIndex.live].status = 1;
        this.contextMenuItems[this.menuIndex.edit].status = 1;
        this.contextMenuItems[this.menuIndex.update].status = 1;
        this.contextMenuItems[this.menuIndex.restart].status = 1;
        if(this.AppState.perm.CSFileManager && !item.disable_filetransfer){
          this.contextMenuItems[this.menuIndex.transfer].status = 1;
        }
        if(this.AppState.perm.useFunction){
          this.contextMenuItems[this.menuIndex.delete].status = 1;
          this.contextMenuItems[this.menuIndex.reboot].status = 1;
          this.contextMenuItems[this.menuIndex.shutdown].status = 1;
        }
      }

      // 온라인 & 제어권없음
      else if (item.alive === 1 && item.approval === 0){
        this.contextMenuItems[this.menuIndex.remote].status = 0;
        this.contextMenuItems[this.menuIndex.transfer].status = 0;
        this.contextMenuItems[this.menuIndex.wol].status = 0;
        this.contextMenuItems[this.menuIndex.approve].status = 1;
        this.contextMenuItems[this.menuIndex.live].status = 0;
        this.contextMenuItems[this.menuIndex.update].status = 0;
        this.contextMenuItems[this.menuIndex.restart].status = 0;
        this.contextMenuItems[this.menuIndex.delete].status = 0;
        this.contextMenuItems[this.menuIndex.reboot].status = 0;
        this.contextMenuItems[this.menuIndex.shutdown].status = 0;
      }

      // 오프라인
      else if (item.alive === 0){
        this.contextMenuItems[this.menuIndex.remote].status = 0;
        this.contextMenuItems[this.menuIndex.transfer].status = 0;
        this.contextMenuItems[this.menuIndex.approve].status = 0;
        this.contextMenuItems[this.menuIndex.live].status = 0;
        this.contextMenuItems[this.menuIndex.update].status = 0;
        this.contextMenuItems[this.menuIndex.restart].status = 0;
        this.contextMenuItems[this.menuIndex.reboot].status = 0;
        this.contextMenuItems[this.menuIndex.shutdown].status = 0;
        if(this.AppState.perm.useFunction){
          this.contextMenuItems[this.menuIndex.delete].status = 1;
        }
        if(this.AppState.isCorporate && this.AppState.perm.useFunction){
          this.contextMenuItems[this.menuIndex.wol].status = 1;
        }
      }
      else {
        //
      }
    },
    // 리스트뷰, 아이콘뷰 우클릭 메뉴 함수
    handleContextMenu(action) {
      const item = this.selectedItem;
      switch(action) {
        // 온라인 + 제어권있음 메뉴
        case 'remote':
          this.openModal('remote', item);
          break;
        case 'transfer':
          this.openModal('transfer', item);
          break;
        case 'detail':
          this.viewDetail(item);
          break;
        case 'live':
          this.showLiveView(item);
          break;
        case 'edit':
          this.editDeviceName(item);
          break;
        /* TODO 프로세스 목록 구현중
          case 'process':
          break;
        */
        case 'update':
          this.updateAgent(item);
          break;
        case 'restart':
          this.openModal('restart', item);
          break;
        case 'delete':
          this.removeDevice(item);
          break;
        case 'reboot':
          this.openModal('reboot', item);
          break;
        case 'shutdown':
          this.openModal('shutdown', item);
          break;
        case 'approve':
          this.approvalStatus(item);
          break;
        case 'wol':
          this.showWOLList(item);
          break;
        case 'location':
          this.showAgentLocationDialog(item);
          break;
      }
    },
    // 우클릭 후 row 밖을 클릭할 경우 우클릭 메뉴 숨김처리
    handleMouseClick(event) {
      this.showMenu = false;
      this.showIconMenu = false;
    },
    // pagination 변경되었을 경우 선택된 에이전트 초기화
    resetSelectedCount(){
      this.devicesOnPage.length = 0;
      this.isIndeterminate = false
      this.isCheckAll = false
      setTimeout(() => {
        this.updateSelectedCount();
      }, 100)
    },
    openDropDown() {
      this.tableClass = "show-dropdown"
    },
    closeDropDown() {
      this.tableClass = ""
    },
    openContextMenu(event) {
      this.menuX = event.clientX;
      this.menuY = event.clientY;
      this.showMenu = true;
    },
    showTooltip(content, event) {
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
      }
      
      this.tooltipTimeout = setTimeout(() => {
        this.tooltip.content = content
        this.tooltip.visible = true
        
        this.tooltip.x = event.pageX + 10
        this.tooltip.y = event.pageY + 20
      }, 400)
    },
    hideTooltip() {
      this.tooltip.visible = false
    },
  },
  watch: {
    $route (route) {
      this.selectedDevices = []
      const pk = this.$route.params.groupPk
      const treeApi = this.$refs.sideTree
      treeApi.traverse(node => {
        if (node.data.pk === pk) {
          if (!node._isSelected) {
            if (!this.$route.params.devicePk) {
              treeApi.select(node.path)
            }
            let path = _.clone(node.path)
            path.pop()

            while(path.length) {
              treeApi.traverse((node, model) => {
                if (_.isEqual(node.path, path)) {
                  Vue.set(model, 'isExpanded', true)
                  return false
                }
              })
              path.pop()
            }
          }
          return false
        }
      })
    },
  },
  computed: {
    devices () {
      let result = []
      const pk = parseInt(this.$route.params.groupPk, 10)

      if (!pk && this.$route.params.groupPk === 'all') result = this.devicelist
      else if (!pk && this.$route.params.groupPk === 'favorate') result = _.filter(this.devicelist, v => v.favorate)
      else result = _.filter(this.devicelist, {device_group_fk: pk})

      if (this.filters.value !== null) {
        result = _.filter(result, v => {
          let value = this.filters.value
          if (typeof value === 'number') return v[this.filters.key.value] === value
          else {
            if (!v[this.filters.key.value]) return false
            return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
          }
        })
      }
      this.page.total = result.length
      return _.map(result, v => {
        v._rowVariant = 'active'
        v._ext = getExt(v.dev_os_id)
        return v
      })
    },
    // 리스트뷰 (테이블) pagination에 따라 보여지는 에이전트
    devicesOnPage () {
      let result = []
      const pk = parseInt(this.$route.params.groupPk, 10)

      if (!pk && this.$route.params.groupPk === 'all') result = this.devicelist
      else if (!pk && this.$route.params.groupPk === 'favorate') result = _.filter(this.devicelist,  v => v.favorate)
      else result = _.filter(this.devicelist, {device_group_fk: pk})
      // sort방식 변경했을 경우, 정렬방식 변경했을 경우 (기본값은 온라인 상태인 에이전트 순으로 정렬)
      if(this.sortDesc){
        result = _.sortBy(this.devicelist, v => !v[this.sortBy])
      } else{
        result = _.sortBy(this.devicelist, v => v[this.sortBy])
      }

      if (this.filters.value !== null) {
        result = _.filter(result, v => {
          let value = this.filters.value
          if (typeof value === 'number') return v[this.filters.key.value] === value
          else return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
        })
      }

      this.page.total = result.length
      let all = _.map(result, v => {
        if (!v.alive) v._rowVariant = 'active'
        v._ext = getExt(v.dev_os_id)
        return v
      })
      let offset = this.page.per * (this.page.current - 1)
      let onPage = _.slice(all, offset, offset + this.page.per)
      return onPage
    },
    // 아이콘뷰 pagination에 따라 보여지는 에이전트 
    devicesOnIconPage () {
      let result = []
      const pk = parseInt(this.$route.params.groupPk, 10)

      if (!pk && this.$route.params.groupPk === 'all') result = this.devicelist
      else if (!pk && this.$route.params.groupPk === 'favorate') result = _.filter(this.devicelist,  v => v.favorate)
      else result = _.filter(this.devicelist, {device_group_fk: pk})

      if (this.filters.value !== null) {
        result = _.filter(result, v => {
          let value = this.filters.value
          if (typeof value === 'number') return v[this.filters.key.value] === value
          else return _.includes(v[this.filters.key.value].toUpperCase(), value.toUpperCase())
        })
      }
      // 온라인 상태인 에이전트 순으로 정렬
      result = _.sortBy(this.devicelist, v => !v.alive)

      this.page_icon.total = result.length
      let all = _.map(result, v => {
        if (!v.alive) v._rowVariant = 'active'
        v._ext = getExt(v.dev_os_id)
        return v
      })
      let offset = this.page_icon.per * (this.page_icon.current - 1)
      let onPage = _.slice(all, offset, offset + this.page_icon.per)
      return onPage
    },
    isRemovableGroup () {
      if(!this.grouplist.length) return false
      let pk = this.$route.params.groupPk
      if (!pk) return false
      let group = _.find(this.grouplist, { pk })
      if (!group) return false
      return !group.flag_df_group
    },
    upperGroup () {
      const pk = this.$route.params.groupPk
        ? parseInt(this.$route.params.groupPk, 10)
        : null

      if (pk === null) return false
      let selectedGroup = _.find(this.grouplist, {pk})
      if (!selectedGroup) return false
      return selectedGroup.group_fk || false
    },
    childGroup () {
      const pk = this.$route.params.groupPk
        ? parseInt(this.$route.params.groupPk, 10)
        : null

      if (pk === null) return []
      return _.filter(this.grouplist, {group_fk: pk})
    },
    groupName () {
      let result = null
      let pk = Number(this.$route.params.groupPk)
      this.grouplist.forEach(v => {
        if (v.pk === pk) {
          result = v.name
        }
      })
      return result
    },
    groupDeviceCount () {
      let result = null
      let pk = Number(this.$route.params.groupPk)
      this.grouplist.forEach(v => {
        if (v.pk === pk) {
          result = v.deviceCount
        }
      })
      return result
    }
  },
  created() {
    EventBus.$on('icon-view-changed', data => {
      this.simpleMode = data
      this.viewMode = this.simpleMode ? 'card' : 'table'
    })
    this.simpleMode = store.get('icon_view')
    this.viewMode = this.simpleMode ? 'card' : 'table'
    document.addEventListener('click', e => this.handleMouseClick(e));
    window.addEventListener("keydown", (e) =>  {
      if (this.showMenu && e.key === 'Escape')
        this.showMenu = false
    })
  },
  mounted () {
    const ahour = 3600000
    const currentTime = new Date().getTime()
    // 사용자에게 등록된 표 또는 이미지 refresh 등록값 호출
    let params = {
      table_name: 'Managers',
      column_name: [
          'refresh_interval', 'img_refresh_interval'
      ]
    }
    
    // 기존 타이머가 설정되어 있으면 해제
    if (this.thumbnailTimer) {
      clearInterval(this.thumbnailTimer);
    }
    if (this.deviceTimer) {
      clearInterval(this.deviceTimer);
    }
    
    tableColumnDataReturnAPI.post('', params)
        .then(resp => {
          const { refresh_interval, img_refresh_interval } = resp.data.objects;
          this.refreshInterval = refresh_interval
          this.imgRefreshInterval = img_refresh_interval
          
          // 썸네일 refresh 관련 내용. -> timestamp 를 변경하여, 썸네일 관련 img 의 cache 의 값을 변경시킴.
          this.thumbnailTimer = setInterval(() => {
            this.timestamp = new Date().getTime()
          }, this.imgRefreshInterval * 1000)
          
          // devices 최신화 하기 위한 타이머 설정
          if (this.refreshInterval) {
            this.deviceTimer = setInterval(() => {
              this.$log.info('[DEVICES REFRESH]')
              this.getSystemUsage()
            }, this.refreshInterval * 1000)
          }
        })
        .catch(error => {
          this.$log.error('[ERROR FETCHING REFRESH INTERVALS]', error)
        })
    
    let stored = store.get(storeKey)
    if (stored) {
      this.$log.info('[DATA RESTORE]')
      _.remove(stored.devices, v => v.pk === 'EMPTY')
      this.page.total = stored.devices.length
      this.devicelist = _.map(stored.devices, v => {
        v.aliasNew = v.alias
        v.memoNew = v.memo
        return v
      })
      this.grouplist = this.groupPermFilter(stored.groups)
      this.setNodes()

      if (stored.updatedAt + ahour < currentTime) {
        this.$log.info('[UPDATED AT A HOUR BEFORE]')
        this.getDataFromServer(storeKey)
      } else {
        this.calcLicense()
      }
    }
    else {
      this.$log.info('[NO CACHED DATA]')
      this.getDataFromServer(storeKey)
    }

    this.getFavorate()

    this.AppState.$on('device-state-change', () => {
      this.$log.info('[DATA CHANGED]')
      this.getDataFromServer('devices')
    })
    
    this.AppState.$on('expanded-data', (data) => {
      if (!this.expandedList.includes(data)) {
        this.expandedList.push(data)
      } else {
        this.expandedList = this.expandedList.filter(v => v !== data)
      }
    })
  },
  beforeDestroy () {
    clearInterval(this.thumbnailTimer)
    clearInterval(this.deviceTimer)
    this.AppState.$off('device-state-change')
    this.AppState.$off('expanded-data')
  },
  data () {
    return {
      lang: this.$i18n.locale,
      currentDevice: null,
      dialogData: {},
      nodes: [],
      groupNodes: [],
      thumbnailTimer: null,
      deviceTimer: null,
      timestamp: 0,
      viewMode: store.get('rememberMode'),
      editModeCheckboxState: true,
      excelLoaded: true,
      isBusy: false,
      nodeTitle: null,
      sidebarTargetNode: {},
      wait: false,
      simpleMode: false,
      selectedCount: 0,
      isCheckAll: false,
      isIndeterminate: false,
      sortBy: 'alive',
      sortDesc: true,
      refreshInterval: null,
      imgRefreshInterval: null,
      selectedDevices: [],
      tooltip: {
        visible: false,
        content: '',
        x: 0,
        y: 0,
      },
      tooltipTimeout: null,
      menuIndex:
      {
        remote: 0,
        transfer: 1,
        wol: 2,
        approve: 3,
        detail: 4,
        live: 5,
        edit: 6,
        process: 7,
        update: 8,
        restart: 9,
        delete: 10,
        reboot: 11,
        shutdown: 12
      },
      // 모든 메뉴는 숨김으로(0) 초기화
      // 사용자 권한에 따라 1로 변경될 예정
      contextMenuItems: [
        {
          text: this.$t('remote.normal.title'),
          action: "remote",
          status: 0
        },
        {
          text: this.$t('remote.transfer.title'),
          action: "transfer",
          status: 0
        },
        {
          text: this.$t('remote.wol.title'),
          action: "wol",
          status: 0
        },
        {
          text: this.$t('remote.approve.desc'),
          action: "approve",
          status: 0
        },
        // 상세보기 메뉴는 모든 사용자에게 제공
        {
          text: this.$t('remote.detail.title'),
          action: "detail",
          status: 1
        },
        {
          text: this.$t('remote.preview.title'),
          action: "live",
          status: 0
        },
        // 에이전트 이름 변경 메뉴는 모든 사용자에게 제공
        {
          text: this.$t('device_name_edit'),
          action: "edit",
          status: 1
        },
        {
          text: this.$t('list_of_process'),
          action: "process",
          status: 0
        },
        {
          text: this.$t('permissions.CSUpdate'),
          action: "update",
          status: 0
        },
        {
          text: this.$t('remote.restart.title'),
          action: "restart",
          status: 0
        },
        {
          text: this.$t('remote.delete.title'),
          action: "delete",
          status: 0
        },
        {
          text: this.$t('remote.reboot.title'),
          action: "reboot",
          status: 0
        },
        {
          text: this.$t('remote.shutdown.title'),
          action: "shutdown",
          status: 0
        },
        {
          text: '에이전트 위치',
          action: "location",
          status: 1
        },
      ],
      showMenu: false,
      menuX: 0,
      menuY: 0,
      showIconMenu: false,
      selectedItem: null,
      menuPosition: {},
      groupCount: {
        usage: 0,
        limit: null
      },
      cardSize: {
        current: 1,
        sizes: [
          {
            lineGap: 240,
            minLineGap: 220,
            maxLineGap: 280,
            height: 246
          },
          {
            lineGap: 300,
            minLineGap: 280,
            maxLineGap: 320,
            height: 200
          },
          {
            lineGap: 440,
            minLineGap: 320,
            maxLineGap: 520,
            height: 200
          },
          {
            lineGap: 580,
            minLineGap: 520,
            maxLineGap: 680,
            height: 200
          }
        ]
      },
      fields: [
        {
          key: 'checkbox',
          label: '',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          thStyle: { minWidth: "40px" },
        },
        {
          key: 'alias',
          label: this.$t('columns.alias'),
          sortable: true,
          thStyle: { minWidth: "200px" },
        },
        {
          key: 'actions',
          label: this.$t('columns.actions'),
          sortable: false,
          thStyle: { minWidth: "120px" },
        },
        {
          key: 'alive',
          label: this.$t('columns.alive'),
          tdClass: 'text-left',
          thClass: 'text-left',
          sortable: true,
          thStyle: { minWidth: "100px" },
        },
        {
          key: 's_pub_ip',
          label: this.$t('ip-address'),
          sortable: true,
          thStyle: { minWidth: "145px" },
        },
        {
          key: 'mac_addr',
          label: 'MAC',
          sortable: true,
          thStyle: { minWidth: "145px" },
        },
        {
          key: 'cpu_usage',
          label: 'CPU',
          sortable: true,
          thStyle: { minWidth: "75px" },
        },
        {
          key: 'memory_usage',
          label: 'MEM',
          sortable: true,
          thStyle: { minWidth: "75px" },
        },
        {
          key: 'hdd_usage',
          label: 'DISK',
          sortable: true,
          thStyle: { minWidth: "75px" },
        },
        {
          key: 'cpu_temp',
          label: this.$t('temperature'),
          sortable: true,
          thStyle: { minWidth: "75px" },
        },
        {
          key: 'dev_os_id',
          label: 'O/S',
          tdClass: 'text-left',
          thClass: 'text-left',
          sortable: true,
          thStyle: { minWidth: "110px" },
        },
        {
          key: 'cs_ver',
          label: `${this.$t('version')}`,
          sortable: true,
          thStyle: { minWidth: "100px" },
        },
        {
          key: 'setting',
          label: this.$t('config'),
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          thStyle: { minWidth: "120px"},
        },
        {
          key: 'favorate',
          label: this.$t('favorate'),
          tdClass: 'text-center',
          thClass: 'text-center',
          sortable: false,
          thStyle: { minWidth: "80px" },
        },
        {
          key: 'last_connected_time',
          label: this.$t('columns.last_connected_time'),
          sortable: true,
          thStyle: { minWidth: "150px" },
        }
      ],
      page: {
        total: 0,
        current: 1,
        per: 24,
        perOptions: [
          { value: 12, text: '12' },
          { value: 24, text: '24' },
          { value: 36, text: '36' }
        ]
      },
      page_icon: {
        total: 0,
        current: 1,
        per: 12,
        perOptions: [
          { value: 12, text: '12' },
          { value: 24, text: '24' },
          { value: 36, text: '36' }
        ]
      },
      grouplist: [],
      devicelist: [],
      expandedList: [],
      filters: {
        val: 'alias',
        value: null,
        key: { value: 'alias', text: this.$t("device_name") },
        keyOptions: [
          { value: 'alias', text: this.$t("device_name") },
          { value: 'dev_os_id', text: this.$t("O/S") },
          { value: 'alive', text: this.$t("status") }
        ],
        osOptions: [
          { value: 1, text: 'Windows' },
          { value: 2, text: 'Linux' },
          { value: 3, text: 'MacOS'},
          { value: 4, text: 'Android' }
        ],
        statusOptions: [
          { value: 1, text: 'Online' },
          { value: 0, text: 'Offline' }
        ]
      },
      filterPreValue: null,
      licenseDialog: {
        show: false,
        summary: {},
        devices: {}
      },
      groupDialog: {
        show: false
      },
      liveView: {
        show: false,
        source: null,
        alive: 0
      },
      wol: {
        show: false,
        device: null
      },
      agent: `${this.AppState.Path.download}/agent`,
      processData: [],
      process_fields: [
        { key: 'name', label: this.$t('name') },
        { key: 'cpu', label: 'CPU ' + this.$t('use_rate') },
        { key: 'memory', label: 'Memory ' + this.$t('use_rate') }
      ],
      tableClass: "",
    }
  }
}